var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-skeleton-loader',{staticClass:"wl-login-loader",attrs:{"type":"avatar"}}),_c('h1',{staticClass:"wl-login-loader-text"},[_vm._v("Logging in ...")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }